<template>
  <div class="content">
    <div class="Tabs">

      <b-tabs card v-model="tabIndex">

        <b-tab :title="lang.tab_QuickView" :title-link-class="textColors" :title-item-class="textColors"
          :active="tabIndex == 0">

          <div v-if="selectedRows.length != 1">
            <p>{{lang.infotext_1}}</p>
          </div>
          <span v-if="!isAssembly">
            <QuickViewTableComponent v-if="selectedRows.length == 1" :source="'false'" :lang="lang.QuickView">
            </QuickViewTableComponent>
          </span>
          <span v-if="isAssembly">
            <QuickViewTableComponent v-if="selectedRows.length == 1" :source="'false'" :lang="lang.QuickView">
            </QuickViewTableComponent>
          </span>
        </b-tab>

        <b-tab v-if="currentUser.role != 'Reader'" :title="lang.tab_Tasks" :title-link-class="textColors"
          :title-item-class="textColors" :active="tabIndex == 1">
          <div v-if="selectedRows.length != 1">
            <p>{{lang.infotext_2}}</p>
          </div>

          <TasksComponent v-if="selectedRows.length == 1" :lang="lang.Tasks" parent="table"></TasksComponent>
        </b-tab>




        <b-tab :title="lang.tab_WhereUse" :title-link-class="textColors" :title-item-class="textColors"
          :active="tabIndex == 2">
          <div v-if="selectedRows.length != 1">
            <p>{{lang.infotext_3}}</p>
          </div>
          <span v-if="appConf.status.isPRM">
            <WhereUseTableComponent :parent="'parts'" v-if="selectedRows.length == 1" :lang="lang.WhereUse">
            </WhereUseTableComponent>
            <br>
          </span>
          <WhatIsIncludedForPartsComponent :parent="'parttable'" v-if="selectedRows.length == 1"
            :lang="lang.WhatIsIncluded"></WhatIsIncludedForPartsComponent>
        </b-tab>
        <b-tab :title="lang.tab_Alternatives" :title-link-class="textColors" :title-item-class="textColors"
          :active="tabIndex == 3">
          <div v-if="selectedRows.length != 1">
            <p>{{lang.infotext_4}}</p>
          </div>
          <AlternativesTableComponent :parent="'parttable'" v-show="!isAlternativeSelected"
            v-if="selectedRows.length == 1" :lang="lang.Alternatives"></AlternativesTableComponent>
          <div v-if="isAlternativeSelected">
            <AlternativeDetailsComponent :lang="lang.AlternativeDetails"></AlternativeDetailsComponent>
          </div>
        </b-tab>
        <b-tab v-if="currentUser.role != 'Reader'" :title="lang.tab_Search" :title-link-class="textColors"
          :title-item-class="textColors" :active="tabIndex == 4">

          <SearchComponent :lang="lang.Search" parent="PartTable"></SearchComponent>

        </b-tab>
        <b-tab :title="lang.tab_Pins" :title-link-class="textColors" :title-item-class="textColors"
          :active="tabIndex == 5">
          <div v-if="selectedRows.length != 1">
            <p>{{ lang.infotext_5 }}</p>
          </div>
          <span v-if="!isNoEmptyLibraries && selectedRows.length == 1">
            <p v-if="selectedRows.length == 1">{{ lang.infotext_6 }}:</p>
            <b-button class="btn analyze-button" size="sm" :variant="variant" @click="analyzePins">
              {{ lang.button_Analyze }}
            </b-button>
            <br><br>
          </span>
          <p v-if="selectedRows.length == 1">{{ lang.infotext_7 }}:</p>

          <PinsPartsSymbolComponent v-if="selectedRows.length == 1" :lang="lang.PinsPartsTable" parent="PartTable">
          </PinsPartsSymbolComponent>

          <PinsPartsHDLSymbolComponent v-if="selectedRows.length == 1" :lang="lang.PinsPartsTable" parent="PartTable">
          </PinsPartsHDLSymbolComponent>

          <PinsPartsFootprintComponent v-if="selectedRows.length == 1" :lang="lang.PinsPartsTable" parent="PartTable">
          </PinsPartsFootprintComponent>
        </b-tab>

      </b-tabs>

    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import QuickViewTableComponent from '@/components/shared/QuickViewTableComponent'
import SearchComponent from '@/components/shared/SearchComponent'
import TasksComponent from '@/components/shared/TasksComponent'
import WhereUseTableComponent from '@/components/shared/WhereUseTableComponent'
import AlternativesTableComponent from '@/components/shared/AlternativesTableComponent'
import AlternativeDetailsComponent from '@/components/shared/AlternativeDetailsComponent'
import WhatIsIncludedForPartsComponent from '@/components/shared/WhatIsIncludedForPartsComponent'
import PinsPartsSymbolComponent from '@/components/shared/PinsPartsSymbolComponent'
import PinsPartsHDLSymbolComponent from '@/components/shared/PinsPartsHDLSymbolComponent'
import PinsPartsFootprintComponent from '@/components/shared/PinsPartsFootprintComponent'

export default {
  name: "Content",
  components: {
    QuickViewTableComponent,
    SearchComponent,
    TasksComponent,
    WhereUseTableComponent,
    AlternativesTableComponent,
    AlternativeDetailsComponent,
    WhatIsIncludedForPartsComponent,
    PinsPartsSymbolComponent,
    PinsPartsHDLSymbolComponent,
    PinsPartsFootprintComponent
  },
  props:{
    lang: Object,

  },
  data () {
    return {
      tabIndex: 0,
      isNoEmptyLibraries: false

    }
  },
  computed: {
    ...mapGetters({
      selectedRows: 'selectedRows',
      isPlugin: 'isPlugin',
      appConf: 'appConf',
      currentUser: 'currentUser'
    }),
    isAssembly(){
      if (this.$store.getters.selectedRows != 0){
        return this.$store.getters.selectedRows[0].col___status.assembly;
      }
      return false;

    },
    isAlternativeSelected(){
      return this.$store.getters.selectedAlternative.distributorPartId != undefined;
    },
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    },
    variant() {
      if (this.$store.getters.s_skinVariant == "dark") {
        return "light";
      } else {
        return "dark";
      }

    },
  },
  created () {
    this.getTabIndex();
  },
  
  watch: {
    tabIndex: function (newVal) {

      let obj = {};
      obj[this.$route.path + "__right"] = newVal;

      this.$store.commit("SETTABDATA", obj);

      //####################
    }

  },
  methods: {
    getTabIndex() {
      
      
      if (this.$store.getters.tabData[this.$route.path + "__right"] != undefined) {
        this.tabIndex = this.$store.getters.tabData[this.$route.path + "__right"];
      } else {
        this.tabIndex = 0;
      }
      
    },
    analyzePins() {
      

      const data = {
        
      }

      let func = function () {

      }

      const obj = {
        title: this.lang.modal_title_modal_PinAnalysis,
        text: "",
        type: "pinAnalysis",
        buttons: 1,
        buttonName: "Close",
        size: "xl",
        lang: this.lang.modal_PinAnalysis,
        funcNo: "",
        funcYes: "",
        funcCustom: func,
        data: data
      };
      this.$store.dispatch("showModalComponent", obj);
    },
  }
}
</script>

<style lang="scss">

  .Tabs{

    .bv-example-row-max{
      max-width: 100%;
      padding-right: 0px;
      padding-left: 0px;
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/PartManager/Views/PartTable/Right/Content/Content.vue